import React from 'react';
import cx from 'classnames';

import { Props as ButtonProps } from '../Button';

import styles from './PopoverFooter.module.scss';
export interface PopoverFooterProps {
  /** Children of `Popover.Footer` which should be one or more `Button` components. */
  children: React.ReactElement<ButtonProps> | React.ReactElement<ButtonProps>[];
  /** CSS className for `Popover.Footer` container. */
  className?: Parameters<typeof cx>[0];
}

export const PopoverFooter: React.FC<PopoverFooterProps> = ({
  children,
  className,
}) => (
  <footer className={cx(styles.popoverFooter, className)}>
    {/* Adding a className to override the button's siblings margin right value. */}
    {React.Children.map(children, child => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          className: cx(child?.props?.className, styles.popoverFooterChild),
        });
      }
      return null;
    })}
  </footer>
);

export default PopoverFooter;
export { styles };
